const TestNewAI = [
  {
    active: false,
    vessel: "Common Iliac",
    criteria: [{ name: "Exclude Stent", active: false }],
  },
  {
    active: false,
    vessel: "External Iliac",
    criteria: [{ name: "Exclude Stent", active: false }],
  },
  {
    active: false,
    vessel: "Common Femoral",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
  {
    active: false,
    vessel: "SFA/Popliteal",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
  {
    active: false,
    vessel: "Tibioperoneal Trunk",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
  {
    active: false,
    vessel: "Anterior Tibial",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
  {
    active: false,
    vessel: "Posterior Tibial",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
  {
    active: false,
    vessel: "Peroneal",
    criteria: [
      { name: "Exclude Stent", active: false },
      { name: "Atherectomy Required", active: false },
    ],
  },
];

export default TestNewAI;
